module.exports = __webpack_public_path__ + "img/emailFormat.9a9aa8af.jpg";